import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles, shorthands } from '@fluentui/react-components';
import { InvestVideoPanelContent } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';
import { useSourceVideos } from './hooks/use-source-videos';
import { AdsStudioAddAssetPanel } from './add-asset-panel';

const useStyles = makeStyles({
  helpLink: {
    color: '#337ab7',
    ...shorthands.textDecoration('underline'),
    fontWeight: 'normal',
    backgroundColor: 'transparent',
    ...shorthands.borderRadius('0px', '0px', '0px', '0px'),
    ...shorthands.border('none'),
  },
});

export const InvestVideoPanel = (props) => {
  const {
    i18n,
    aid, cid, oDataConfig,
    dataService, logger, notificationApi, navigation, open, perfMarker,
  } = props;
  const classes = useStyles();

  const {
    setSelectedVideos, onInvestClickSelect, showBlocker, selectedVideos,
  } = useSourceVideos({
    dataService, logger, navigation, perfMarker,
  });

  const dismiss = useCallback(() => {
    navigation.goBack();
  }, [navigation]);

  useEffect(() => {
    if (selectedVideos && selectedVideos.length === 1) {
      const handleJobErrors = (jobErrors) => {
        if (jobErrors.length > 0) {
          const genericError = (
            <span>
              { i18n.getString(_TL_('One or more assets failed to upload. Please try again')) }
              <button className={classNames(`HelpTopic ${classes.helpLink}`)} query="help:app54863">{i18n.getString(_TL_('Learn more about asset guidelines and accepted file types.'))}</button>
            </span>
          );
          notificationApi.showWarning(genericError);
        }
      };
      onInvestClickSelect(handleJobErrors);
    }
  }, [classes.helpLink, i18n, notificationApi, selectedVideos]);

  return (
    <AdsStudioAddAssetPanel
      aid={aid}
      i18n={i18n}
      dismiss={dismiss}
      isOpen={open}
      showBlocker={showBlocker}
      selectedAsset={selectedVideos}
      headerText={i18n.getString(_TL_('Videos from Microsoft Invest'))}
      logger={logger}
      notificationApi={notificationApi}
      onClickSelect={onInvestClickSelect}
      isMultiSelection={false}
    >
      <InvestVideoPanelContent i18n={i18n} aid={aid} cid={cid} oDataConfig={oDataConfig} setSelectedVideos={setSelectedVideos} logger={logger} />
    </AdsStudioAddAssetPanel>
  );
};

InvestVideoPanel.propTypes = {
  i18n: PropTypes.shape({}).isRequired,
  navigation: PropTypes.shape({
    gotoVideosPage: PropTypes.func,
    goBack: PropTypes.func,
  }).isRequired,
  dataService: PropTypes.shape({
    uploadInvestVideo: PropTypes.func,
  }).isRequired,
  logger: PropTypes.shape({
    logTrace: PropTypes.func,
  }).isRequired,
  aid: PropTypes.number.isRequired,
  cid: PropTypes.number.isRequired,
  oDataConfig: PropTypes.shape({}).isRequired,
  notificationApi: PropTypes.shape({
    showWarning: PropTypes.func,
  }).isRequired,
  open: PropTypes.bool.isRequired,
};
